// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PromoCard_card__3jpS6 {
  position: relative;
  border-radius: 18px;
  box-shadow: var(--shadow-card);
  padding: 26px 24px;
  min-height: 150px;
  overflow: hidden;
  background:
    radial-gradient(120% 130% at 115% 15%, rgba(247, 148, 30, 0.55) 0%, rgba(247, 148, 30, 0.05) 38%, transparent 60%),
    #111214;
  display: flex;
  align-items: flex-end;
}

.PromoCard_text__tMYcH {
  position: relative;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.15;
  color: #fff;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Dashboard/components/PromoCard.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB;;WAES;EACT,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,SAAS;AACX","sourcesContent":[".card {\n  position: relative;\n  border-radius: 18px;\n  box-shadow: var(--shadow-card);\n  padding: 26px 24px;\n  min-height: 150px;\n  overflow: hidden;\n  background:\n    radial-gradient(120% 130% at 115% 15%, rgba(247, 148, 30, 0.55) 0%, rgba(247, 148, 30, 0.05) 38%, transparent 60%),\n    #111214;\n  display: flex;\n  align-items: flex-end;\n}\n\n.text {\n  position: relative;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.15;\n  color: #fff;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `PromoCard_card__3jpS6`,
	"text": `PromoCard_text__tMYcH`
};
export default ___CSS_LOADER_EXPORT___;
